var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 658 429",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--404",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "404---logged-out",
    transform: "translate(-391.000000, -324.000000)",
    fill: "#F0F2F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(391.411707, 271.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.68700166,297.090925 C-8.23507959,206.115817 5.08718061,95.5844991 218.301267,65.0012235 C431.515353,34.4179479 568.445019,61.9675132 631.537505,181.885956 C694.629992,301.804399 623.920648,416.495302 601.830313,436.790028 C579.739978,457.084754 500.169977,494.782595 328.562612,476.740974 C156.955248,458.699354 13.6090829,388.066033 2.68700166,297.090925 Z",
    id: "Path-2-Copy"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayBg);
export default __webpack_public_path__ + "static/media/gray-bg.27de118b9fce3edee880a02f18338c31.svg";
export { ForwardRef as ReactComponent };